<template>
    <form-row title="Scheduled Closing Date">
        <input-date
            v-model="date"
            name="scheduled_closing_date"
            :read_only="read_only"
            input_id="scheduled-closing-date"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        date: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>
